var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03345 3H8.38007L6.20214 7.21968H2.49438C2.50766 7.20315 2.5212 7.18678 2.535 7.17057L5.45016 3.74548C5.85403 3.27098 6.42954 3 7.03345 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.90759C2.03926 9.30976 2.18119 9.70393 2.42752 10.0438L11.091 22L6.13552 8.90759H2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85571 8.90759L12 19.8569L16.1443 8.90759H7.85571Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8645 8.90759L12.909 22L21.5725 10.0438C21.8188 9.70393 21.9607 9.30976 22 8.90759H17.8645Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5056 7.21968H17.7979L15.62 3H16.9666C17.5705 3 18.146 3.27098 18.5499 3.74548L21.465 7.17057C21.4788 7.18678 21.4924 7.20315 21.5056 7.21968Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9786 7.21968H8.02142L10.1993 3H13.8007L15.9786 7.21968Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.7541d15f376dee222aaaa5767e1d0e3f.svg";
export { ForwardRef as ReactComponent };